// File: /src/routes/AppRoutes.js

import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import Projects from '../pages/Projects';
import FinanceDashboard from '../pages/FinanceDashboard';
import UserAccount from '../pages/UserAccount';
import GridClients from '../pages/GridClients';
import ResetPassword from '../pages/ResetPassword';
import KanbanBoard from '../components/KanbanBoard';
import { useAuth } from '../contexts/AuthContext';

const Calendar = React.lazy(() => import('../pages/Calendar'));

const LoadingFallback = () => (
	<div
		style={{
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			height: '60vh',
		}}
	>
		<p className="loading-text">
			Carregando...
			<br />
			<span className="loading-spinner"></span>
		</p>
	</div>
);

const AppRoutes = () => {
	const { isAuthenticated, loading } = useAuth();

	if (loading) {
		return <LoadingFallback />;
	}

	return (
		<Routes>
			<Route
				path="/login"
				element={
					isAuthenticated ? (
						<Navigate to="/" replace />
					) : (
						<Login />
					)
				}
			/>

			<Route path="/" element={<PrivateRoute />}>
				<Route index element={<Dashboard />} />
				<Route path="projects" element={<Projects />} />
				<Route path="kanban" element={<KanbanBoard />} />
				<Route path="finance" element={<FinanceDashboard />} />
				<Route path="calendar" element={
					<Suspense fallback={<LoadingFallback />}>
						<Calendar />
					</Suspense>
				} />
				<Route path="user-account" element={<UserAccount />} />
				<Route path="grid-clients" element={<GridClients />} />
			</Route>

			<Route
				path="/reset-password"
				element={
					isAuthenticated ? (
						<Navigate to="/" replace />
					) : (
						<ResetPassword />
					)
				}
			/>

			<Route
				path="*"
				element={
					<Navigate to={isAuthenticated ? '/' : '/login'} replace />
				}
			/>
		</Routes>
	);
};

export default AppRoutes;
